import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import {
  TextAreaField,
  ITextAreaField,
} from '@app/infrastructure/models/form/textarea';
import { FormService } from '@core/services/form.service';
import { IFormConfig, FormConfig, FormField } from '@models/form/form';
import { SaveCancelService } from '@core/services/state/save-cancel.service';
import { RequiredValidation } from '@utils/validation/required-validation';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormComponent implements OnInit {
  @Input() public currentImageFile: string = '';
  @Input() public formConfig: IFormConfig = new FormConfig();
  @Input() public removeSpacing: boolean = false;

  @Output() public emitForm = new EventEmitter<UntypedFormGroup>();
  @Output() public emitSubmit = new EventEmitter<void>();

  public form: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private formService: FormService,
    private saveCancelService: SaveCancelService,
  ) {}

  public ngOnInit(): void {
    this.form = this.createFormAndPropagateToParent();
  }

  public getPosition(position: string) {
    let style: string = '';

    switch (position) {
      case 'center':
        style = 'center';
        break;
    }

    return style;
  }

  public submit(): void {
    this.emitSubmit.emit();
    this.saveCancelService.setDisabledState(true);
  }

  private createFormAndPropagateToParent(): UntypedFormGroup {
    // For file uploads, since the file might already just exist on the server and all we're doing is displaying a preview, it has to be approached differently from regular inputs where we can just mirror what the server has
    const hiddenFields = [];

    for (const control of this.formConfig.controls) {
      if (control.fieldType === 'file') {
        hiddenFields.push(
          new FormField<ITextAreaField>({
            name: `${control.name}HiddenField`,
            hiddenField: true,
            value: control.hiddenValue,
            fieldType: 'textarea',
            label: `${control.name}HiddenField`,
            fieldConfig: new TextAreaField(),
            validation: [RequiredValidation.required(`${control.name}`)],
            required: true,
            showErrorMessages: false,
          }),
        );
      }
    }

    this.formConfig.controls = [...this.formConfig.controls, ...hiddenFields];

    const form = this.formService.buildForm(this.formConfig);
    this.emitForm.emit(form);

    return form;
  }
}
